import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { AdminUsageDto } from 'src/api/FiretrolApiClient';
import { useAdminUsageSummary } from 'src/api/queries/chatAdmin/useAdminUsageSummary';
import { AnchorLink } from 'src/design/molecules/AnchorLink';
import { PAGE_SIZE } from 'src/routes/Settings/AIAssistant/constants';
import {
  useTable,
  useTableState,
} from 'src/design/organisms/DataTable/useTable';
import { formatDate } from 'src/utils';

const getColumns = (): MRT_ColumnDef<AdminUsageDto>[] => [
  {
    accessorKey: 'userName',
    header: 'User',
    Cell: ({ cell, row }) => (
      <AnchorLink to={`/settings/ai-assistant/users/${row.original.userId}`}>
        {cell.getValue<string>()}
      </AnchorLink>
    ),
  },
  {
    accessorKey: 'usageDate',
    header: 'Date',
    Cell: ({ cell }) => formatDate(cell.getValue<string>()),
  },
  {
    accessorKey: 'inputTokens',
    header: 'Input Tokens',
  },
  {
    accessorKey: 'outputTokens',
    header: 'Output Tokens',
  },
  {
    accessorKey: 'cacheReadTokens',
    header: 'Cache Read Tokens',
  },
  {
    accessorKey: 'requestCount',
    header: 'Requests',
  },
  {
    accessorKey: 'estCostUsd',
    header: 'Est. Cost (USD)',
    Cell: ({ cell }) => `$${cell.getValue<number>().toFixed(2)}`,
  },
];

export const UsageTab: React.FC = () => {
  const usageQuery = useAdminUsageSummary({ page: 1, pageSize: PAGE_SIZE });
  const usage = usageQuery.data?.items ?? [];

  const columns = useMemo(() => getColumns(), []);

  const tableState = useTableState({
    identifier: 'ai-assistant-usage',
    columns,
    defaultSorting: [{ id: 'usageDate', desc: true }],
  });

  const { table } = useTable({
    ...tableState,
    tableOptions: {
      enableRowActions: false,
      enableClickToCopy: false,
      columns,
      data: usage,
      manualPagination: false,
      manualSorting: false,
      manualFiltering: false,
    },
    totalCount: usage.length,
    isLoading: usageQuery.isLoading,
    isFetching: usageQuery.isFetching,
    isError: usageQuery.isError,
    onRefresh: usageQuery.refetch,
  });

  return table;
};
